import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { combinedSettingsSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import classnames from "classnames";
import Component, { type TimerProps } from "./component";
import { makeCountdownOptionsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const countdownOptionsSelector = makeCountdownOptionsSelector();
  const moduleApiInfoSelector = makeModuleApiInfoSelector();

  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "timerSize",
    "timerStyle",
    "timerColor",
    "elementVisibility",
    "countTypeFunnel"
  ]);

  return (state: AppState, props: RootContainerProps): TimerProps => {
    const settings = settingsSelector(state, props);

    return {
      apiInfo: moduleApiInfoSelector(state, props),
      className: classnames(
        "countdown",
        settings.timerSize,
        settings.timerStyle,
        settings.timerColor,
        settings.elementVisibility.split(",")
      ),
      countdownOptions: countdownOptionsSelector(state, props),
      isEditMode: state.isEditMode,
      isInheritFunnel: settings.countTypeFunnel === "inherit-funnel",
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
